<template>
  <div v-if="max > 0" class="c-moduleCase"
    @touchstart="swipe"
    @touchend="swipe"
    @touchcancel="swipe"
  >
    <ul class="c-moduleCase__wrap" :style="styleWrap" :class="{'c-moduleCase__wrap--noTool': max == 1}">
      <li v-for="(c, index) in params" ref="c-moduleCase__wrap__li" style="visibility: hidden;">
        <div class="c-moduleCase__slide">
          <a :href="c.url"><div class="c-moduleCase__slideWrap" :style="{'background-image': `url(${c.img})`}"></div></a>
        </div>

        <div class="c-moduleCase__info">
          <div class="c-moduleCase__infoWrap">
            <h2 class="f-ITC-BoldIt">WORKS</h2>
            <h3 v-html="c.title.ja"></h3>
            <h4 v-html="c.title.en"></h4>
            <a class="c-moduleCase__infoView" :href="c.url">
              <div><span>VIEW MORE</span></div>
            </a>
          </div>
        </div>
      </li>
    </ul>

    <div v-show="max > 1" class="c-moduleCase__infoTool">
      <div class="c-moduleCase__infoTool__seek">
        <ul>
          <li v-for="(c, index) in params" :class="{'isSelected': index === current}"></li>
        </ul>
      </div>
      <div class="c-moduleCase__infoTool__prev" @click="changeCarousel('prev')"><span></span></div>
      <div class="c-moduleCase__infoTool__next" @click="changeCarousel('next')"><span></span></div>
    </div>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import {TweenMax, Cubic} from 'gsap/all';

  export default {
    data() {
      return {
        isTransition: true,
        assets_path: assets_path,
        styleWrap: '',
        direction: 1,
        params: [],
        max: 0,
        current: 0,
        next: 0,
        touchStartX: 0,
        touchMoveX: 0,
        touchStartTime: 0,
        autoTime: 6000,
        autoTimer: null,
        isAutoStart: true,
        slidePosY: 0,
      }
    },
    store,
    computed: {
    },
    created() {
    },
    mounted() {
      this.params = JSON.parse(document.getElementById('js-param-casestudy').textContent);
      this.max = this.params.length;
      if (this.max > 0) {
        this.styleWrap = `width:${this.max * 100}%`;
        this.$nextTick(this.setting);
      }
    },
    methods: {
      setting() {
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.scroll);
        this.resize();
      },
      start() {
        const slide = this.$refs['c-moduleCase__wrap__li'][this.current];
        const photo = slide.querySelector('.c-moduleCase__slideWrap');
        const info = slide.querySelector('.c-moduleCase__infoWrap');

        TweenMax.fromTo(slide, 0.5,
          {
            opacity: 0,
            visibility: 'visible'
          },{
            opacity: 1,
            ease: Cubic.easeOut,
            onComplete: this.startComp
          });

        TweenMax.fromTo(photo, 0.5,
          {
            //x: '20%',
            opacity: 0,
            visibility: 'visible'
          },{
            //x: '0%',
            opacity: 1,
            ease: Cubic.easeOut
          });

        TweenMax.fromTo(info, 0.5,
          {
            x: '15%',
            opacity: 0,
            visibility: 'visible'
          },{
            x: '0%',
            opacity: 1,
            ease: Cubic.easeOut
          });
      },
      startComp() {
        this.isTransition = false;

        if (this.isAutoStart) {
          this.autoTimer = setTimeout(this.changeCarousel.bind(this, 'next'), this.autoTime);
        }
      },
      changeCarousel(direction) {
        if (this.isTransition) return;
        this.isTransition = true;

        this.direction = (direction === 'prev') ? -1 : 1;
        this.next = this.getNext(direction);
        this.hideSlide();
      },
      slideCarousel() {
        this.hideSlide();
      },
      hideSlide() {
        const slide = this.$refs['c-moduleCase__wrap__li'][this.current];
        const photo = slide.querySelector('.c-moduleCase__slideWrap');
        const info = slide.querySelector('.c-moduleCase__infoWrap');

        TweenMax.killTweensOf([slide, photo, info]);

        TweenMax.to(photo, 0.4,
          {
            //x: (-15 * this.direction) + '%',
            opacity: 0,
            ease: Cubic.easeIn
          });

        TweenMax.to(info, 0.4,
          {
            x: (-10 * this.direction) + '%',
            opacity: 0,
            ease: Cubic.easeIn,
            onComplete: this.hideSlideComp
          });
      },
      hideSlideComp() {
        const slide = this.$refs['c-moduleCase__wrap__li'][this.current];

        TweenMax.set(slide,
          {
            x: '100%',
            visibility: 'hidden'
          });

        this.showSlide();
      },
      showSlide() {
        const slide = this.$refs['c-moduleCase__wrap__li'][this.next];
        const photo = slide.querySelector('.c-moduleCase__slideWrap');
        const info = slide.querySelector('.c-moduleCase__infoWrap');

        TweenMax.killTweensOf([slide, photo, info]);

        TweenMax.set(slide,
          {
            x: (-100 * this.next) + '%',
            visibility: 'visible'
          });

        TweenMax.fromTo(photo, 0.5,
          {
            //x: (30 * this.direction) + '%',
            opacity: 0,
            visibility: 'visible'
          },{
            //x: '0%',
            opacity: 1,
            ease: Cubic.easeOut
          });

        TweenMax.fromTo(info, 0.5,
          {
            x: (20 * this.direction) + '%',
            opacity: 0,
            visibility: 'visible'
          },{
            x: '0%',
            opacity: 1,
            ease: Cubic.easeOut,
            onComplete: this.showSlideComp
          });

        this.current = this.next;
        this.isTransition = false;
      },
      showSlideComp() {
        if (this.isAutoStart) {
          clearTimeout(this.autoTimer);
          this.autoTimer = setTimeout(this.changeCarousel.bind(this, 'next'), this.autoTime);
        }
      },
      swipe(e) {
        //e.preventDefault();
        if (this.$store.getters.isShowGnav) return;
        //if (this.isTransition) return;

        if (e.type === 'touchstart') {
          /** タッチ開始 */
          this.touchStartX = e.touches[0].pageX;
          this.touchStartTime = Date.now();

        } else if (e.type === 'touchend') {
          /** タッチ完了で状態を判定 */
          this.touchMoveX = e.changedTouches[0].pageX - this.touchStartX;

          let direction = '';
          if (this.touchMoveX > 0) {
            direction = 'prev';
          } else {
            direction = 'next';
          }

          if (Math.abs(this.touchMoveX) > 30 && Date.now() - this.touchStartTime <= 300) {
            // 遷移する
            this.changeCarousel(direction);
          } else if (Math.abs(this.touchMoveX) > (window.innerHeight / 2.5)) {
            // 遷移する
            this.changeCarousel(direction);
          }
        }
      },
      getNext(direction) {
        let next = 0;
        if (direction === 'prev') {
          next = this.current - 1;
          if (next < 0) next = this.max - 1;
        } else {
          next = (this.current + 1) % this.max;
        }
        return next;
      },
      scroll() {
        if (this.slidePosY < this.$_currentScrollY()) {
          this.start();
          this.reset();
        }
      },
      resize() {
        this.slidePosY = this.$_getOffsetTop(this.$el).top - (window.innerHeight * 0.9);
        this.scroll();
      },
      reset() {
        window.removeEventListener('resize', this.resize);
        window.removeEventListener('scroll', this.scroll);
      }
    }
  }
</script>
